import React, { useEffect, useState } from 'react';
import { Spin, Tabs, Modal, Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import './index.less';
import GoogleMapReact from '@/components/GoogleMapReact';
import {
    soilCheckQueryNameIsExist,
    soilGetQuery,
    soilSaveQuery,
    soilSearchGetAllProfilePoint,
    soilSearchGetPointsByCoordinatesRadiusProperty,
    soilSearchGetProfilePointByPolygonOrCircle,
    soilSearchGetProfilePointsByAreaIds,
    soilSearchGetProfileTableViewByPolygonOrCircle,
    soilSearchGetProfileTableViewDataByAreas,
    soilSearchSoilProfileTableView,
} from '@/util/Request';
import {
    GetPropertyListResponseModel,
    ISoilProfilePlaceGeoNames,
    ISoilSearchProfilePointResModel,
    ISoilSearchTableViewResModel,
} from '@/util/Request/requestType';
import AdminAreaComponent from './Component/AdminAreaComponent';
import CoordinateBaseTab from './Component/CoordinateBaseTab';
import SoilSearchDetailComponent from './Component/SoilSearchDetailComponent';
import FirstTabComponent from './Component/FirstTabComponent';
import IF from '@/components/IF';
import {
    SoilCloseIcon,
    SoilProfileCloseIcon,
    SoilProfileWarningAlertIcon,
    SoilSearchLeftArrow,
    SoilSearchStar
} from '@/resource/IconComponentSets';
import { RootState } from '@/redux';
import { updateFirstIn, updateFirstTabValues, updateFromQueryHistory, updateSecondTabValues, updateSoilQueryGuid, updateSoilQueryId, updateThirdTabValues } from '@/redux/reducer/soilSerach';
import DrawOnMapTab from './Component/DrawOnMapTab';
import { updateSuccessMessage, updateWarningMessage } from '@/redux/reducer/common';
import { ICoordinate } from '@/components/GoogleMapReact/GoogleMapReactComponent';

const { confirm } = Modal;

const SoilQuery = () => {
    const {
        firstIn,
        soilPropertyList,
        soilQueryId,
        isMapView,
        queryGuid,
        // first tab values
        selectedPropertySet,
        currentRadius,
        placeSelectSet,
        // second tab values
        coordinatesSet,
        coordinateTabRadius,
        coordinateTabPropertiesSet,
        // third tab values
        areaIds,
        adminiTabPropertySet,
        checkedNames,
        expandedKeys,
        checkedKeys,
        // fourth tab values
        polyPoint,
        drawPolyTabPropertiesSet,
        drawCircleMode,
        drawReactModel,
        radius,
        circlePoint,
        center
    } = useSelector((state: RootState) => state.soilSearchPageData);

    const [currentPage, setCurrentPage] = useState<string>('0');
    const [isFetching, setIsFetching] = useState(false);
    const [firstInAlertVisible, setFirstInAlertVisile] = useState(false);
    const [placeAlertVsible, setPlaceAllertVsible] = useState(false);
    const [soilPropertiesAlertVisible, setSoilPropertiesAlertVisible] = useState(false);
    const [splitByCountry, setSplitByCountry] = useState(false);
    const [exchangeMapOrTableEnbale, setExchangeMapOrTableEnbale] = useState(false);

    // first tab states
    const [placeBasedProfilePointSet, setPlaceBasedProfilePointSet] = useState<ISoilSearchProfilePointResModel[]>([]);
    const [placeBasedProfileTableViewData, setPlaceBasedProfileTableViewData] = useState<ISoilSearchTableViewResModel[]>([]);
    const [placeFilterPropertySet, setPlaceFilterPropertySet] = useState<GetPropertyListResponseModel[]>();

    // second tab states
    const [coordinateBasedProfilePointSet, setCoordinateBasedProfilePointSet] = useState<ISoilSearchProfilePointResModel[]>([]);
    const [coordinateBasedProfileTableViewData, setCoordinateBasedProfileTableViewData] = useState<ISoilSearchTableViewResModel[]>([]);
    const [coordinateFilterPropertySet, setCoordinateFilterPropertySet] = useState<GetPropertyListResponseModel[]>();

    // third tab states
    const [adminBasedProfilePointSet, setAdminBasedProfilePointSet] = useState<ISoilSearchProfilePointResModel[]>([]);
    const [adminBasedProfileTableViewData, setAdminBasedProfileTableViewData] = useState<ISoilSearchTableViewResModel[]>([]);
    const [adminFilterPropertySet, setAdminFilterPropertySet] = useState<GetPropertyListResponseModel[]>();

    // fourth tab state
    const [drawpolyBasedProfilePointSet, setDrawpolyBasedProfilePointSet] = useState<ISoilSearchProfilePointResModel[]>([]);
    const [drawpolyBasedBasedProfileTableViewData, setDrawpolyBasedBasedProfileTableViewData] = useState<ISoilSearchTableViewResModel[]>([]);
    const [polyPointFilterPropertySet, setPolyPointFilterPropertySet] = useState<GetPropertyListResponseModel[]>();
    const [clearMapTag, setClearMapTag] = useState<number>(0);

    const [inputQueryShow, setInputQueryShow] = useState(false);
    const [queryIsFetching, setQueryIsFetching] = useState(false);
    const [queryName, setQueryName] = useState('');
    // saved query id
    const [nameQueryId, setNameQueryId] = useState(0);
    const [coordinateQueryId, setCoordinateQueryId] = useState(0);
    const [admiQueryId, setAdmiQueryId] = useState(0);
    const [drawQueryId, setDrawQueryId] = useState(0);

    const dispatch = useDispatch();

    // SECTION: normal function area
    const tabChange = (e: string) => {
        setCurrentPage(e);
    };

    // select none condition to search point
    const refreshAllProfilesPoint = async () => {
        try {
            const result = await soilSearchGetAllProfilePoint();
            setPlaceBasedProfilePointSet(result);
        } catch(err) {
            console.log(err);
        }
    };

    const commomWarning = (message: string) => {
        return confirm({
            className: 'soil-profile-warning-div',
            okButtonProps: { style: { borderRadius: '16px', width: '80px' }},
            title: '',
            icon: (
                <div style={{height: '50px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <SoilProfileWarningAlertIcon />
                    <span style={{
                        color: '#14151C',
                        fontSize: '16px',
                        fontFamily: 'Noto-Sans-Semibold',
                        fontWeight: 600,
                        marginLeft: '17px'
                    }}>
                        Warning
                    </span>
                </div>),
            content: message,
            okText: 'OK',
            onCancel() {
                console.log('Cancel');
            },
            onOk: () => {
                console.log('click ok button');
            }
        });
    };

    const placeBaseTabExecuteButtonClick = async (isMapView: boolean, splitByCountry: boolean) => {
        saveQueryFunc(true);
        // if click the execute button set the first in value to false
        searchForPlaceSetData(
            selectedPropertySet,
            isMapView,
            placeSelectSet,
            currentRadius,
            splitByCountry
        );
    };

    const searchForPlaceSetData = async (
        selectedPropertySet: GetPropertyListResponseModel[],
        isMapView: boolean,
        placeSelectSet: ISoilProfilePlaceGeoNames[],
        currentRadius: number,
        splitByCountry: boolean
    ): Promise<void> => {
        try {
            dispatch(updateFirstIn(false));
            setIsFetching(true);
            const firstProperty = selectedPropertySet[0];
            let propertySet = [...selectedPropertySet];
            if (firstProperty.id === -10) {
                const chemicalAll = soilPropertyList.filter((item) => item.category === 'Chemical' );
                const others = selectedPropertySet.filter((item) => item.category === 'Physical');
                propertySet = [...chemicalAll, ...others];
            }
            if (firstProperty.id === -20) {
                const physicalAll = soilPropertyList.filter((item) => item.category === 'Physical' );
                const others = selectedPropertySet.filter((item) => item.category === 'Chemical');
                propertySet = [...physicalAll, ...others];
            }
            setPlaceFilterPropertySet(propertySet);
            const propertiesArr = propertySet.map(item => {
                return item.id;
            });
            const propertiesIdString = propertiesArr.join(',');
            if (isMapView) {
                const coordinatesString = placeSelectSet.map((item) => {
                    return `(${item.lng}, ${item.lat})`;
                });
                const response = await soilSearchGetPointsByCoordinatesRadiusProperty({
                    coordinates: JSON.stringify(coordinatesString),
                    radius: currentRadius,
                    propertiesIDs: propertiesIdString
                });
                setPlaceBasedProfilePointSet(response);
                if (response.length === 0) {
                    commomWarning('No point match current search conditions!');
                }
            } else {
                const coordinateList = placeSelectSet.map((item) => {
                    return {
                        locationName: `${item.name},${item.adminName1}`,
                        lat: item.lat,
                        lng: item.lng
                    };
                });
                const requestData = {
                    coordinateList,
                    isScrollDown: false,
                    isSplitByCountry: splitByCountry,
                    propertiesIDs: propertiesIdString,
                    searchRadius: currentRadius
                };

                const res = await soilSearchSoilProfileTableView(requestData);
                setPlaceBasedProfileTableViewData(res);
            }
            setIsFetching(false);
        } catch(err) {
            setIsFetching(false);
            console.log(err);
        }
    };

    const coordinateTabExecuteButtonClick = async (isMapView: boolean, splitByCountry:boolean) => {
        // if click the execute button set the first in value to false
        saveQueryFunc(true);
        searchForCoordinateData(
            coordinateTabPropertiesSet,
            isMapView,
            coordinatesSet,
            coordinateTabRadius,
            splitByCountry
        );
    };

    const searchForCoordinateData = async (
        coordinateTabPropertiesSet: GetPropertyListResponseModel[],
        isMapView: boolean,
        coordinatesSet: string[],
        coordinateTabRadius: number,
        splitByCountry: boolean
    ) => {
        try {
            dispatch(updateFirstIn(false));
            setIsFetching(true);
            const firstProperty = coordinateTabPropertiesSet[0];
            let propertySet = [...coordinateTabPropertiesSet];
            if (firstProperty.id === -10) {
                const chemicalAll = soilPropertyList.filter((item) => item.category === 'Chemical' );
                const others = coordinateTabPropertiesSet.filter((item) => item.category === 'Physical');
                propertySet = [...chemicalAll, ...others];
            }
            if (firstProperty.id === -20) {
                const physicalAll = soilPropertyList.filter((item) => item.category === 'Physical' );
                const others = coordinateTabPropertiesSet.filter((item) => item.category === 'Chemical');
                propertySet = [...physicalAll, ...others];
            }
            setCoordinateFilterPropertySet(propertySet);
            const propertiesArr = propertySet.map(item => {
                return item.id;
            });
            const propertiesIdString = propertiesArr.join(',');

            const coordinateList = coordinatesSet.map((item) => {
                const jsonItem = item.replace(/"/g, '').replace('(', '').replace(')', '').split(',');
                return {
                    locationName: '',
                    lat: parseFloat(jsonItem[1]),
                    lng: parseFloat(jsonItem[0])
                };
            });
            if (isMapView) {
                const response = await soilSearchGetPointsByCoordinatesRadiusProperty({
                    coordinates: JSON.stringify(coordinatesSet),
                    radius: coordinateTabRadius,
                    propertiesIDs: propertiesIdString
                });
                setCoordinateBasedProfilePointSet(response);
                if (response.length === 0) {
                    commomWarning('No point match current search conditions!');
                }
            } else {
                const requestData = {
                    coordinateList,
                    isScrollDown: false,
                    isSplitByCountry: splitByCountry,
                    propertiesIDs: propertiesIdString,
                    searchRadius: coordinateTabRadius
                };

                const response = await soilSearchSoilProfileTableView(requestData);
                setCoordinateBasedProfileTableViewData(response);
            }
            setIsFetching(false);
        } catch(err) {
            setIsFetching(false);
            console.log(err);
        }
    };

    const adminTabExecuteButtonClick = async (isMapView: boolean, splitByCountry: boolean) => {
        saveQueryFunc(true);
        searchForAdminData(
            adminiTabPropertySet,
            isMapView,
            areaIds,
            splitByCountry
        );
    };

    const searchForAdminData = async (
        adminiTabPropertySet: GetPropertyListResponseModel[],
        isMapView: boolean,
        areaIds: string[],
        splitByCountry: boolean
    )=> {
        try {
            dispatch(updateFirstIn(false));
            // if click the execute button set the first in value to false
            setIsFetching(true);
            const firstProperty = adminiTabPropertySet[0];
            let propertySet = [...adminiTabPropertySet];
            if (firstProperty.id === -10) {
                const chemicalAll = soilPropertyList.filter((item) => item.category === 'Chemical' );
                const others = adminiTabPropertySet.filter((item) => item.category === 'Physical');
                propertySet = [...chemicalAll, ...others];
            }
            if (firstProperty.id === -20) {
                const physicalAll = soilPropertyList.filter((item) => item.category === 'Physical' );
                const others = adminiTabPropertySet.filter((item) => item.category === 'Chemical');
                propertySet = [...physicalAll, ...others];
            }
            setAdminFilterPropertySet(propertySet);
            const propertiesArr = propertySet.map(item => {
                return item.id;
            });
            const propertiesIdString = propertiesArr.join(',');
            const areaIdString = areaIds.join(',');

            if (isMapView) {
                const res = await soilSearchGetProfilePointsByAreaIds({
                    areaIDs: areaIdString,
                    propertiesIDs: propertiesIdString
                });
                setAdminBasedProfilePointSet(res);
                if (res.length === 0) {
                    commomWarning('No point match current search conditions!');
                }
            } else {
                const res = await soilSearchGetProfileTableViewDataByAreas(
                    areaIdString,
                    propertiesIdString,
                    splitByCountry
                );
                setAdminBasedProfileTableViewData(res);
            }
            setIsFetching(false);
        } catch (err) {
            setIsFetching(false);
        }
    };

    const drawPolyTabExecuteButtonClick = async (isMapView: boolean, splitByCountry: boolean) => {
        saveQueryFunc(true);
        searchForDrawPolyData(
            drawPolyTabPropertiesSet,
            isMapView,
            drawReactModel ? polyPoint : (drawCircleMode ? circlePoint : []),
            splitByCountry
        );
    };

    const searchForDrawPolyData = async (
        drawPolyTabPropertiesSet: GetPropertyListResponseModel[],
        isMapView: boolean,
        polyPoint: ICoordinate[],
        splitByCountry: boolean
    ) => {
        try {
            if (polyPoint.length === 0) {
                return commomWarning('Please add a circle on map!');
            }
            setIsFetching(true);
            const firstProperty = drawPolyTabPropertiesSet[0];
            let propertySet = [...drawPolyTabPropertiesSet];
            if (firstProperty.id === -10) {
                const chemicalAll = soilPropertyList.filter((item) => item.category === 'Chemical' );
                const others = drawPolyTabPropertiesSet.filter((item) => item.category === 'Physical');
                propertySet = [...chemicalAll, ...others];
            }
            if (firstProperty.id === -20) {
                const physicalAll = soilPropertyList.filter((item) => item.category === 'Physical' );
                const others = drawPolyTabPropertiesSet.filter((item) => item.category === 'Chemical');
                propertySet = [...physicalAll, ...others];
            }
            setPolyPointFilterPropertySet(propertySet);
            const propertiesArr = propertySet.map(item => {
                return item.id;
            });
            const propertiesIdString = propertiesArr.join(',');
            let polyPointString = '';
            polyPoint.forEach((point, index) => {
                const lngLatString = `(${point.lng},${point.lat})`;
                if (index > 0) {
                    return polyPointString += `,${lngLatString}`;
                }
                polyPointString += lngLatString;
            });
            const lngLatString = `(${polyPointString})`;

            if (isMapView) {
                const res = await soilSearchGetProfilePointByPolygonOrCircle({
                    polygon: lngLatString,
                    propertiesIDs: propertiesIdString
                });
                setDrawpolyBasedProfilePointSet(res);
                if (res.length === 0) {
                    commomWarning('No point match current search conditions!');
                }
            } else {
                const res = await soilSearchGetProfileTableViewByPolygonOrCircle({
                    polygon: lngLatString,
                    propertiesIDs: propertiesIdString,
                    isSplitByCountry: splitByCountry
                });
                setDrawpolyBasedBasedProfileTableViewData(res);
            }
            setIsFetching(false);
        } catch(err) {
            setIsFetching(true);
            console.log('err', err);
        }
    };

    const saveQueryFunc = async (autoSave: boolean) => {
        try {
            if (!autoSave) {
                // if isn't auto save mode check the query name is exist or not also need to check query name
                if (queryName.length === 0) {
                    return dispatch(updateWarningMessage('Query name can\'t be null'));
                }
                const res = await soilCheckQueryNameIsExist(queryName);
                if (res.data) {
                    setQueryIsFetching(false);
                    return dispatch(updateWarningMessage('The query name is exist!'));
                }
            }

            let queryId;
            let requestParam: unknown;
            switch (currentPage) {
                case '0': {
                    queryId = nameQueryId;
                    if (!selectedPropertySet || (selectedPropertySet && selectedPropertySet.length === 0)) {
                        if (!autoSave) {
                            return dispatch(updateWarningMessage('property can\'t be null'));
                        } else {
                            return;
                        }
                    }
                    if (isMapView) {
                        requestParam = {
                            placeSelectSet,
                            selectedPropertySet,
                            currentRadius,
                        };
                    } else {
                        requestParam = {
                            placeSelectSet,
                            selectedPropertySet,
                            isScrollDown: false,
                            splitByCountry,
                            currentRadius
                        };
                    }
                    break;
                }
                case '1': {
                    queryId = coordinateQueryId;
                    if (!coordinatesSet || (coordinatesSet && coordinatesSet.length === 0)) {
                        if (!autoSave) {
                            return dispatch(updateWarningMessage('coordinate can\'t be null'));
                        } else {
                            return;
                        }
                    }
                    if (!coordinateTabPropertiesSet || (coordinateTabPropertiesSet && coordinateTabPropertiesSet.length === 0)) {
                        if (!autoSave) {
                            return dispatch(updateWarningMessage('property can\'t be null'));
                        } else {
                            return;
                        }
                    }
                    if (isMapView) {
                        requestParam = {
                            coordinatesSet,
                            coordinateTabRadius,
                            coordinateTabPropertiesSet
                        };
                    } else {
                        requestParam = {
                            coordinatesSet,
                            isScrollDown: false,
                            splitByCountry,
                            coordinateTabPropertiesSet,
                            coordinateTabRadius
                        };
                    }
                    break;
                }
                case '2': {
                    queryId = admiQueryId;
                    if (!areaIds || areaIds && areaIds.length === 0) {
                        if (!autoSave) {
                            return dispatch(updateWarningMessage('the selected area can\'t be null'));
                        } else {
                            return;
                        }
                    }
                    if (!adminiTabPropertySet || (adminiTabPropertySet && adminiTabPropertySet.length === 0)) {
                        if (!autoSave) {
                            return dispatch(updateWarningMessage('property can\'t be null'));
                        } else {
                            return;
                        }
                    }
                    if (isMapView) {
                        requestParam = {
                            areaIds,
                            adminiTabPropertySet,
                            checkedNames,
                            expandedKeys,
                            checkedKeys
                        };
                    } else {
                        requestParam = {
                            areaIds,
                            adminiTabPropertySet,
                            splitByCountry,
                            checkedNames,
                            expandedKeys,
                            checkedKeys
                        };
                    }
                    break;
                }
                case '3': {
                    queryId === drawQueryId;
                    if (!drawPolyTabPropertiesSet || (drawPolyTabPropertiesSet && drawPolyTabPropertiesSet.length === 0)) {
                        if (!autoSave) {
                            return dispatch(updateWarningMessage('property can\'t be null'));
                        } else {
                            return;
                        }
                    }
                    if (drawReactModel && (!polyPoint || (polyPoint && polyPoint.length === 0))) {
                        if (!autoSave) {
                            return dispatch(updateWarningMessage('selected points can\'t be null'));
                        } else {
                            return;
                        }
                    }
                    if (drawCircleMode && (!circlePoint || (circlePoint && circlePoint.length === 0))) {
                        if (!autoSave) {
                            return dispatch(updateWarningMessage('circle can\'t be null'));
                        } else {
                            return;
                        }
                    }
                    if (isMapView) {
                        requestParam = {
                            polyPoint,
                            circlePoint,
                            drawPolyTabPropertiesSet,
                            drawCircleMode,
                            drawReactModel,
                            radius,
                            center
                        };
                    } else {
                        requestParam = {
                            polyPoint,
                            circlePoint,
                            drawPolyTabPropertiesSet,
                            splitByCountry,
                            drawCircleMode,
                            drawReactModel,
                            radius,
                            center
                        };
                    }
                    break;
                }
            }
            const options = {
                ...requestParam as object,
                currentPage,
                isMapView,
            };
            setQueryIsFetching(true);

            const res = await soilSaveQuery({
                queryId,
                queryName: autoSave ? '' : queryName,
                options: JSON.stringify(options)
            });
            switch(currentPage) {
                case '0': {
                    setNameQueryId(res.data);
                    break;
                }
                case '1': {
                    setCoordinateQueryId(res.data);
                    break;
                }
                case '2': {
                    setCoordinateQueryId(res.data);
                    break;
                }
                case '3': {
                    setDrawQueryId(res.data);
                    break;
                }
            }
            // reset the request param
            setQueryName('');
            // show success message
            if (!autoSave) {
                dispatch(updateSuccessMessage('Save the query successfully!'));
            }
            setQueryIsFetching(false);
            setInputQueryShow(false);
        } catch(err) {
            setQueryIsFetching(false);
            dispatch(updateWarningMessage('Save the query failed!'));
        }
    };

    const getTargetQuery = async (queryId: number, queryGuid?: string) => {
        try {
            let res;
            if (queryId != 0 && queryId != null) {
                res = await soilGetQuery(queryId);
            }
            if (queryGuid && queryGuid.length > 0) {
                res = await soilGetQuery(null, queryGuid);
            }
            const queryData = res.data;
            const options = JSON.parse(queryData.options);
            switch(options.currentPage) {
                case '0': {
                    dispatch(updateFirstTabValues({
                        selectedPropertySet: options?.selectedPropertySet,
                        currentRadius: options?.currentRadius,
                        placeSelectSet: options?.placeSelectSet,
                        splitByCountry: options?.splitByCountry,
                        isMapView: options?.isMapView,
                        fromQueryHistory: true
                    }));
                    setCurrentPage(options?.currentPage);
                    // request for first tab data
                    searchForPlaceSetData(
                        options?.selectedPropertySet,
                        options?.isMapView,
                        options?.placeSelectSet,
                        options?.currentRadius,
                        options?.splitByCountry,
                    );
                    break;
                }
                case '1': {
                    dispatch(updateSecondTabValues({
                        coordinatesSet: options?.coordinatesSet,
                        coordinateTabRadius: options?.coordinateTabRadius,
                        coordinateTabPropertiesSet: options?.coordinateTabPropertiesSet,
                        isMapView: options?.isMapView,
                        fromQueryHistory: true
                    }));
                    setCurrentPage(options?.currentPage);
                    searchForCoordinateData(
                        options?.coordinateTabPropertiesSet,
                        options?.isMapView,
                        options?.coordinatesSet,
                        options?.coordinateTabRadius,
                        options?.splitByCountry
                    );
                    break;
                }
                case '2': {
                    dispatch(updateThirdTabValues({
                        areaIds: options?.areaIds,
                        adminiTabPropertySet: options?.adminiTabPropertySet,
                        checkedKeys: options?.checkedKeys,
                        expandedKeys: options?.expandedKeys,
                        fromQueryHistory: true
                    }));
                    setCurrentPage(options?.currentPage);
                    searchForAdminData(
                        options?.adminiTabPropertySet,
                        options?.isMapView,
                        options?.areaIds,
                        options?.splitByCountry
                    );
                    break;
                }
                case '3': {
                    dispatch(updateThirdTabValues({
                        polyPoint: options?.polyPoint,
                        drawPolyTabPropertiesSet: options?.drawPolyTabPropertiesSet,
                        circlePoint: options?.circlePoint,
                        radius: options?.radius,
                        fromQueryHistory: true,
                        drawReactModel: options?.drawReactModel,
                        drawCircleMode: options?.drawCircleMode,
                        center: options?.center
                    }));
                    setCurrentPage(options?.currentPage);
                    searchForDrawPolyData(
                        options?.drawPolyTabPropertiesSet,
                        options?.isMapView,
                        (options?.drawReactModel && options?.polyPoint) || (options?.drawCircleMode && options?.circlePoint),
                        options?.splitByCountry
                    );
                    break;
                }
            }
        } catch (err) {
            console.log('err:===', err);
        }
    };

    const handleSplitByCountryButtonClicked = (splitByCountry: boolean) => {
        // if exchagne map view on the right side, is would be refresh all
        if (parseInt(currentPage) === 0) {
            if (placeSelectSet.length > 0 && selectedPropertySet.length > 0) {
                placeBaseTabExecuteButtonClick(isMapView, splitByCountry);
            }
        }
        if (parseInt(currentPage) === 1) {
            if (coordinateTabPropertiesSet.length > 0 && coordinatesSet.length > 0) {
                coordinateTabExecuteButtonClick(isMapView, splitByCountry);
            }
        }
        if (parseInt(currentPage) === 2) {
            if (areaIds.length > 0 && adminiTabPropertySet.length > 0) {
                adminTabExecuteButtonClick(isMapView, splitByCountry);
            }
        }
        if (parseInt(currentPage) === 3) {
            if (polyPoint.length > 0 && drawPolyTabPropertiesSet.length > 0) {
                drawPolyTabExecuteButtonClick(isMapView, splitByCountry);
            }
        }
    };

    const handleMapViewButtonClicked = (isMapView: boolean) => {
        // if exchagne map view on the right side, is would be refresh all
        if (parseInt(currentPage) === 0) {
            if (placeSelectSet.length > 0 && selectedPropertySet.length > 0) {
                placeBaseTabExecuteButtonClick(isMapView, splitByCountry);
            }
        }
        if (parseInt(currentPage) === 1) {
            if (coordinateTabPropertiesSet.length > 0 && coordinatesSet.length > 0) {
                coordinateTabExecuteButtonClick(isMapView, splitByCountry);
            }
        }
        if (parseInt(currentPage) === 2) {
            if (areaIds.length > 0 && adminiTabPropertySet.length > 0) {
                adminTabExecuteButtonClick(isMapView, splitByCountry);
            }
        }
        if (parseInt(currentPage) === 3) {
            if (polyPoint.length > 0 && drawPolyTabPropertiesSet.length > 0) {
                drawPolyTabExecuteButtonClick(isMapView, splitByCountry);
            }
        }
    };

    // SECTION: useEffect ared here
    useEffect(() => {
        const locationArr = location.pathname.split('/');
        const queryGuid = locationArr[2];
        const pathname = locationArr[1];
        if (pathname === 'search' && queryGuid) {
            dispatch(updateSoilQueryGuid(queryGuid));
            dispatch(updateFromQueryHistory(true));

        }
    }, [location]);

    useEffect(() => {
        if (soilQueryId != 0) {
            getTargetQuery(soilQueryId);
            dispatch(updateSoilQueryId(0));
        }
        if (queryGuid && queryGuid.length > 0) {
            getTargetQuery(null, queryGuid);
            dispatch(updateSoilQueryId(0));
        }
    }, [soilQueryId, queryGuid]);

    useEffect(() => {
        console.log('just invoke once');
        const head = document.getElementsByTagName('head')[0];
        const googleAnalyticsCode = 'G-83GCC2D5LZ';
        const googleAnalyticsFirstScript = document.createElement('script');
        googleAnalyticsFirstScript.async = true;
        googleAnalyticsFirstScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + googleAnalyticsCode;

        const googleAnalyticsSecondScript = document.createElement('script');
        googleAnalyticsSecondScript.innerHTML =
          '    window.dataLayer = window.dataLayer || [];\n' +
          '    function gtag(){dataLayer.push(arguments);}\n' +
          '    gtag(\'js\', new Date());\n' +
          '\n' +
          '    gtag(\'config\', \'' +
          googleAnalyticsCode +
          '\',{\n' +
          'cookie_flags:\'max-age=7200;secure;samesite-none\'' +
          '});';

        head.insertBefore(googleAnalyticsSecondScript, head.firstChild);
        head.insertBefore(googleAnalyticsFirstScript, head.firstChild);
    }, []);


    // new user guides
    useEffect(() => {
        setNameQueryId(0);
    }, [currentRadius, placeSelectSet, selectedPropertySet]);

    useEffect(() => {
        setAdmiQueryId(0);
    }, [adminiTabPropertySet, areaIds]);

    useEffect(() => {
        setCoordinateQueryId(0);
    }, [coordinateTabRadius, coordinateTabPropertiesSet, coordinatesSet]);

    useEffect(() => {
        setDrawQueryId(0);
    }, [drawPolyTabPropertiesSet, drawpolyBasedProfilePointSet]);

    useEffect(() => {
        if (placeBasedProfilePointSet.length > 0 && firstIn) {
            setFirstInAlertVisile(true);
        }
    }, [placeBasedProfilePointSet, firstIn]);

    useEffect(() => {
        if (placeSelectSet.length > 0 && firstIn) {
            if (firstInAlertVisible ) {
                setFirstInAlertVisile(false);
            }
            setPlaceAllertVsible(true);
        }
    }, [placeSelectSet, firstIn]);

    useEffect(() => {
        if (selectedPropertySet.length > 0 && firstIn) {
            if (placeAlertVsible) {
                setPlaceAllertVsible(false);
            }
            setSoilPropertiesAlertVisible(true);
        }
    }, [selectedPropertySet, firstIn]);

    useEffect(() => {
        setIsFetching(false);
        if (currentPage === '0') {
            const tableViewEnable = selectedPropertySet.length > 0 && selectedPropertySet.length > 0;
            setExchangeMapOrTableEnbale(tableViewEnable);
        }

        if (currentPage === '1') {
            const tableViewEnable = coordinateTabPropertiesSet.length > 0 && coordinatesSet.length > 0;
            setExchangeMapOrTableEnbale(tableViewEnable);
        }

        if (currentPage === '2') {
            const tableViewEnable = adminiTabPropertySet.length > 0 && areaIds.length > 0;
            setExchangeMapOrTableEnbale(tableViewEnable);
        }
        if (currentPage === '3') {
            const tableViewEnable = drawPolyTabPropertiesSet.length > 0 && (polyPoint?.length > 0 || circlePoint?.length > 0);
            setExchangeMapOrTableEnbale(tableViewEnable);
        }
    }, [
        currentPage,
        selectedPropertySet,
        coordinateTabPropertiesSet,
        coordinatesSet,
        adminiTabPropertySet,
        areaIds,
        drawPolyTabPropertiesSet,
        polyPoint
    ]);

    const saveButtonClicked = () => {
        setInputQueryShow(true);
    };

    useEffect(() => {
        refreshAllProfilesPoint();
    }, []);

    const items = [
        { label: 'Location', key: '0', children: (
            <FirstTabComponent
                excuteButtonClick={() => placeBaseTabExecuteButtonClick(isMapView, splitByCountry)}
                propertiesDivClick={() => {
                    setPlaceAllertVsible(false);
                    setSoilPropertiesAlertVisible(true);
                }}
                saveQueryButtonClick={saveButtonClicked}
            />
        )},
        { label: 'Coordinates', key: '1', children: (
            <CoordinateBaseTab
                excuteButtonClick={() => coordinateTabExecuteButtonClick(isMapView, splitByCountry)}
                saveQueryButtonClick={saveButtonClicked}
            />
        )},
        { label: 'Regions', key: '2', children: (
            <AdminAreaComponent
                isSplitByCountry={splitByCountry}
                executeButtonClick={() => adminTabExecuteButtonClick(isMapView, splitByCountry)}
                saveQueryButtonClick={saveButtonClicked}
            />
        )},
        { label: 'Draw on map', key: '3', children: (
            <DrawOnMapTab
                executeCallback={() => drawPolyTabExecuteButtonClick(isMapView, splitByCountry)}
                clearButtonClick={() => {
                    const newClearMapTag = clearMapTag + 1;
                    setClearMapTag(newClearMapTag);
                }}
                saveQueryButtonClick={saveButtonClicked}
            />
        )},
    ];

    // SECTION: render part
    return (
        <div className='query-map-container'>
            <div className='query-map-menu-action-panel'>
                <div className='soil-analysis-query-header'>
                    <h3>Soil analysis query</h3>
                </div>
                <div className='select-tabs-menu-set'>
                    <h4>Select location by</h4>
                    <Tabs
                        activeKey={currentPage}
                        onChange={tabChange}
                        style={{ height: '100%' }}
                        items={items}
                    />
                </div>
            </div>
            <Modal
                open={inputQueryShow}
                className={'query-in-modal'}
                title={'Save query'}
                footer={null}
                onCancel={() => setInputQueryShow(false)}
                closeIcon={<SoilCloseIcon />}
                destroyOnClose={true}
            >
                <Spin spinning={queryIsFetching}>
                    <div>
                        <span className='save-query-span-des'>Check the Query Name before first. <br /> Location, enviroment and growing data will be save</span>
                        <div className='input-div'>
                            <span>Query name</span>
                            <Input onChange={(e) => setQueryName(e.target.value)} value={queryName} />
                        </div>
                        <div className='query-input-button-div'>
                            <button
                                onClick={() => {
                                    setQueryName('');
                                    setInputQueryShow(false);
                                }}
                            >
                                Cancel and return
                            </button>
                            <button
                                onClick={() => saveQueryFunc(false)}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </Spin>
            </Modal>
            <div className='map-div'>
                <IF show={firstInAlertVisible && currentPage === '0'}>
                    <div className='first-in-container'>
                        <div className = 'up-div'>
                            <button onClick = {() => setFirstInAlertVisile(false)}>
                                <SoilProfileCloseIcon />
                            </button>
                        </div>
                        <div className='down-div'>
                            <div className='left-container'>
                                <SoilSearchStar />
                            </div>
                            <div className='right-container'>
                                <span>
                                    We already have data on {placeBasedProfilePointSet.length} soil profiles from all continents in our database. You can see them on the map as green pins.
                                </span>
                                <div className='separte-div'/>
                                <span>
                                    Select Location or Soil properties to clarify the search area
                                </span>
                            </div>
                        </div>
                    </div>
                </IF>
                <IF show={placeAlertVsible && firstIn && currentPage === '0'}>
                    <div className='place-first-in-container'>
                        <div className = 'up-div'>
                            <button onClick = {() => {
                                setPlaceAllertVsible(false);
                            }}>
                                <SoilProfileCloseIcon />
                            </button>
                        </div>
                        <div className='down-div'>
                            <div className='left-container'>
                                <SoilSearchLeftArrow />
                            </div>
                            <div className='right-container'>
                                <span>
                                    Good news for you!
                                </span>
                                <div className='separte-div'/>
                                <span>
                                    You can choose more locations by clicking Add location.
                                </span>
                            </div>
                        </div>
                    </div>
                </IF>
                <IF show={soilPropertiesAlertVisible && firstIn && currentPage === '0'}>
                    <div className='properties-first-in-container'>
                        <div className = 'up-div'>
                            <button onClick = {() => {
                                setSoilPropertiesAlertVisible(false);
                                dispatch(updateFirstIn(false));
                            }}>
                                <SoilProfileCloseIcon />
                            </button>
                        </div>
                        <div className='down-div'>
                            <div className='left-container'>
                                <SoilSearchLeftArrow />
                            </div>
                            <div className='right-container'>
                                <span>
                                    Use soil properties for accurate search results. The physical and chemical properties of the soil are available for the search.
                                </span>
                            </div>
                        </div>
                    </div>
                </IF>
                <IF show={isMapView}>
                    <Spin spinning={isFetching}>
                        <GoogleMapReact
                            clearMapTag={clearMapTag}
                            propertySet={(
                                currentPage === '0' && placeFilterPropertySet) || (
                                currentPage === '1' && coordinateFilterPropertySet) || (
                                currentPage === '2' && adminFilterPropertySet) || (
                                currentPage === '3' && polyPointFilterPropertySet)
                            }
                            type='QUERY'
                            defaultZoom={3}
                            coordinates={(
                                currentPage === '0' && placeBasedProfilePointSet) || (
                                currentPage === '1' && coordinateBasedProfilePointSet) || (
                                currentPage === '2' && adminBasedProfilePointSet) || (
                                currentPage === '3' && drawpolyBasedProfilePointSet)
                            }
                            showPolyMenu={currentPage === '3'}
                        />
                    </Spin>
                </IF>
                <IF show={!isMapView}>
                    <SoilSearchDetailComponent
                        spining={isFetching}
                        currentPage={currentPage}
                        soilSearchTableviewData={(
                            currentPage === '0' && placeBasedProfileTableViewData) || (
                            currentPage === '1' && coordinateBasedProfileTableViewData) || (
                            currentPage === '2' && adminBasedProfileTableViewData) || (
                            currentPage === '3' && drawpolyBasedBasedProfileTableViewData)
                        }
                        propertySet={(
                            currentPage === '0' && placeFilterPropertySet) || (
                            currentPage === '1' && coordinateFilterPropertySet) || (
                            currentPage === '2' && adminFilterPropertySet) || (
                            currentPage === '3' && polyPointFilterPropertySet)}
                        splitByCountryCallback={(splitByCountry) => {
                            handleSplitByCountryButtonClicked(splitByCountry);
                            setSplitByCountry(splitByCountry);
                        }}
                    />
                </IF>
            </div>
            <button
                className={`toggle_change-map-or-table ${exchangeMapOrTableEnbale ? 'exchange-tableview-enable-status' : 'exchange-tableview-disable-status'} `}
                onClick={() => {
                    if (exchangeMapOrTableEnbale) {
                        handleMapViewButtonClicked(!isMapView);
                        dispatch(updateFirstTabValues({ isMapView: !isMapView }));
                    }
                }}>
                {isMapView ? 'Table view' : 'Map view'}
            </button>
        </div>
    );
};

export default SoilQuery;
